<bp-information-page-shell>
	<bp-spinning-logo></bp-spinning-logo>
</bp-information-page-shell>
